// import React, { useEffect, useState } from 'react';
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import Signup from './adminDashboard/signup/Signup';
import Signin from './adminDashboard/signin/Signin';
import Home from "./adminDashboard/attendance/Home";
import Dashboard from "./adminDashboard/dashboard/Dashboard";
import Students from "./adminDashboard/students/Students";
import Teachers from "./adminDashboard/teachers/Teachers";
import Courses from "./adminDashboard/courses/Courses";
import CourseInfo from "./adminDashboard/courses/CourseInfo";
import Competitions from "./adminDashboard/competitions/Competitions";
import AddStudent from "./adminDashboard/forms/AddStudent";
import AddCourse from "./adminDashboard/forms/AddCourse";
import AdminDashboardLayout from "./components/AdminDashboardLayout";
import SignInUpLayout from "./components/SignInUpLayout";
import SessionExpiryBanner from "./components/SessionExpiryBanner";
import ClassRoomLayout from "./components/ClassRoomLayout";
import Calendar from "./adminDashboard/calendar/Calendar";
import ClassRoomHome from "./classrooms/pages/home/ClassRoomHome";
import ClassRoomPeople from "./classrooms/pages/people/ClassRoomPeople";
import ClassesLayout from "./components/ClassesLayout";
import Classes from "./classrooms/pages/classes/Classes";
import Homework from "./classrooms/pages/homework/Homework";
import AddTeacher from "./adminDashboard/forms/AddTeacher";
import Modules from "./classrooms/pages/modules/Modules";
import SubmitPage from "./classrooms/pages/homework/SubmitPage";
import ClassLogs from "./classrooms/pages/classLogs/ClassLogs";
import AdminHomework from "./adminDashboard/homework/Homework";
import AdminClassLogs from "./adminDashboard/students/classLogs/ClassLogs";
import HwGrading from "./classrooms/pages/homework/grading/Grading";
import ClassMaterials from "./classrooms/pages/classMaterials/ClassMaterials";
import ZoomRooms from "./adminDashboard/zoomRooms/ZoomRooms";
import AddZoomRoom from "./adminDashboard/forms/AddZoomRoom";
import Announcements from "./classrooms/pages/announcements/Announcements";
import AddSemester from "./adminDashboard/forms/AddSemester";
import PotentialStudents from "./adminDashboard/potentialStudents/PotentialStudents";
import EmailGenerator from "./adminDashboard/consultationProgress/EmailGenerator";
import ZoomRecordings from "./classrooms/pages/zoomRecordings/ZoomRecordings";
import ForgotPassword from "./adminDashboard/signin/ForgotPassword";
import ResetPassword from "./adminDashboard/signin/ResetPassword";
import Questions from "./classrooms/pages/questions/Questions";
import AdminQuestions from "./adminDashboard/questions/Questions";
import AdminSchoolMaterials from "./adminDashboard/schoolMaterials/SchoolMaterials";
// import ZoomAssignPage from "./adminDashboard/zoomRooms/ZoomAssignPage";
import AddTextbook from "./adminDashboard/forms/AddTextbook";
import Textbooks from "./adminDashboard/textbooks/Textbooks";
import TextbookExercises from "./adminDashboard/textbooks/TextbookExercises";
import HWQuestionsAttempts from "./classrooms/pages/homework/hwQuestionsAttempts/HWQuestionsAttempts";
import EssayFeedbackPage from "./classrooms/pages/homework/essayFeedback/EssayFeedbackPage";
import PotentialTeachers from "./adminDashboard/potentialTeachers/PotentialTeachers";
import ConsultationProgress from "./adminDashboard/consultationProgress/ConsultationProgress";
import PotentialCourses from "./adminDashboard/potentialCourses/PotentialCourses";
import EmailDrafts from "./adminDashboard/emailDrafts/EmailDrafts";
import AddTest from "./adminDashboard/forms/AddTest";
import Test from "./classrooms/pages/tests/Test";
import Tests from "./adminDashboard/tests/Tests";
import ViewTest from "./adminDashboard/tests/ViewTest";
import EditTest from "./adminDashboard/tests/EditTest";
import TestResults from "./adminDashboard/testResults/TestResults";
import TestLibrary from "./adminDashboard/testsV2/TestLibrary";
import AddEditTestV2 from "./adminDashboard/testsV2/AddEditTest";
import GenerateTestWizard from "./adminDashboard/testsV2/GenerateTestWizard";
import QuestionBank from "./adminDashboard/questionBank/QuestionBank";
import TagManager from "./adminDashboard/tags/TagManager";
import TestSubmitPage from "./classrooms/pages/tests/TestSubmitPage";
import TestResult from "./classrooms/pages/tests/TestResult";
import StudentResult from "./classrooms/pages/tests/StudentResult";
import TeacherReviewPage from "./classrooms/pages/teacherReview/TeacherReviewPage";
import TestSessionV2 from "./classrooms/pages/tests/v2/TestSession";
import TestResultV2 from "./classrooms/pages/tests/v2/TestResultV2";
import TestReviewV2 from "./classrooms/pages/tests/v2/TestReviewV2";
import StudentResultV2 from "./classrooms/pages/tests/v2/StudentResultV2";
import Weekly from "./adminDashboard/weekly/Weekly";
import { SnackbarProvider } from 'notistack';
import PaycheckCalculator from "./adminDashboard/paycheckCalculator/PaycheckCalculator";
import StudentCards from "./studentCards/StudentCards";
import Unsubscription from "./newsLetters/Unsubscription";
import Maintenance from "./maintenance/Maintenance";
// import MaintenanceModal from "./components/MaintenanceModal";
// import React from "react";
import NewsLetters from "./newsLetters/NewsLetters";
import VicePresidentMemos from "./adminDashboard/vicePresidentMemos/VicePresidentMemos";
import ManagerMemos from "./adminDashboard/managerMemos/ManagerMemos";
// import DataETL from "./adminDashboard/dataETL/dataETL";
import DataPage from "./adminDashboard/dataETL/DataPage";
import TaskScheduler from "./adminDashboard/taskScheduler/TaskDashboard";
import MissedCalls from "./adminDashboard/missedCalls/MissedCalls";
import PaymentLinksPage from "./adminDashboard/paymentLinks/PaymentLinksPage";
import MissedCallsUpload from "./adminDashboard/missedCalls/MissedCallsUpload";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ParentForm  from "./makeupSchedule/ParentForm"
import TeacherForm from "./makeupSchedule/TeacherForm"
import MakeupDashboard from "./adminDashboard/makeupScheduler/MakeupDashboard";
import APTestProgress from "./adminDashboard/apTestProgress/APTestProgress";
import PlacementTestProgress from "./adminDashboard/placementTestProgress/PlacementTestProgress";
import PlacementTakerPage from "./classrooms/pages/tests/v2/PlacementTakerPage";
import AppointmentAvailability from "./adminDashboard/appointmentAvailability/AppointmentAvailability";
import GroupParentForm from "./makeupSchedule/GroupParentForm";
import MakeupFormLayout from "./components/MakeupFormLayout";
import Reports from "./adminDashboard/reports/Reports";
import ReportGeneration from "./adminDashboard/reports/ReportGeneration";
import ReportProgress from "./adminDashboard/reports/ReportProgress";
import ReportViewer from "./adminDashboard/reports/ReportViewer";
import Newsletters from "./adminDashboard/newsletters/Newsletters";
import NewsletterGeneration from "./adminDashboard/newsletters/NewsletterGeneration";
import NewsletterProgress from "./adminDashboard/newsletters/NewsletterProgress";
import NewsletterViewer from "./adminDashboard/newsletters/NewsletterViewer";
import AICompetitionSavePage from "./adminDashboard/newsletters/AICompetitionSavePage";
import ClassLogBatch from "./adminDashboard/classLogBatch/ClassLogBatch";
import EmailFollowupsDev from "./adminDashboard/emailFollowupsDev/EmailFollowupsDev";
import ParentPortalLinkPage from "./adminDashboard/parentPortalLink/ParentPortalLinkPage";
import ETTReports from "./adminDashboard/ettReports/ETTReports";
import ETTReportDetail from "./adminDashboard/ettReports/ETTReportDetail";
import PrepPrograms from "./adminDashboard/prepPrograms/PrepPrograms";
import PrepProgramEditor from "./adminDashboard/prepPrograms/PrepProgramEditor";
import PrepProgramDashboard from "./adminDashboard/prepPrograms/PrepProgramDashboard";
import PrepDevTools from "./adminDashboard/prepPrograms/PrepDevTools";
import ClassroomETTReports from "./classrooms/pages/ettReports/ClassroomETTReports";
import ClassroomETTReportDetail from "./classrooms/pages/ettReports/ClassroomETTReportDetail";
import KeyRemediationReview from "./adminDashboard/homework/KeyRemediationReview";
const isMaintenanceMode = false;


function App() {
    const [theme, colorMode] = useMode();

    // for maintenance modal
    // const [maintenanceOpen, setMaintenanceOpen] = React.useState(false);
    // const handleMaintenanceOpen = () => setMaintenanceOpen(true);
    // const handleMaintenanceClose = () => setMaintenanceOpen(false);
    // React.useEffect(() => {
    //     if (!isMaintenanceMode) {
    //         handleMaintenanceOpen();
    //     }
    // }, []);

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CssBaseline />
                <SnackbarProvider maxSnack={5}>
                    <div className="app">
                        <SessionExpiryBanner />
                        {/* {!isMaintenanceMode && <MaintenanceModal open={maintenanceOpen} handleClose={handleMaintenanceClose} />} */}
                        <Routes>
                            {isMaintenanceMode ? (
                                <>
                                    <Route path="*" element={<Navigate to={"/maintenance"} />} />
                                    <Route path="/maintenance" element={<Maintenance />} />
                                </>
                            ) : (
                                <>
                                    <Route path="/news-letters/unsubscription" element={<Unsubscription />} />
                                    <Route path="/students/:uuid/info_card" element={<StudentCards />} />
                                    <Route path="/placement/:token" element={<PlacementTakerPage />} />
                                    <Route path="/missed-calls-upload" element={<MissedCallsUpload />} />
                                    <Route element={<MakeupFormLayout />}>
                                        <Route path="/makeup/teacher/:tid" element={<TeacherForm />} />
                                        <Route path="/makeup/parent/:pid" element={<ParentForm />} />
                                        <Route path="/group-makeup/parent/:pid" element={<GroupParentForm />} />
                                    </Route>
                                    <Route element={<AdminDashboardLayout/>}>
                                        <Route path="/" element={<Dashboard />} />
                                        <Route path="/admin/home" element={<Dashboard />} />
                                        <Route path="/admin/attendance" element={<Home />} />
                                        <Route path="/admin/weekly" element={<Weekly />} />
                                        <Route path="/admin/potentialCourses" element={<PotentialCourses />} />
                                        <Route path="/admin/students" element={<Students />} />
                                        <Route path="/admin/students/:id/class-logs" element={<AdminClassLogs />} />
                                        <Route path="/admin/potentialStudents" element={<PotentialStudents />} />
                                        <Route path="/admin/consultationProgress" element={<ConsultationProgress />} />
                                        <Route path="/admin/consultationProgress/:id/emailGenerator" element={<EmailGenerator />} />
                                        <Route path="/admin/taskScheduler" element={<TaskScheduler />} />
                                        <Route path="/admin/missedCalls" element={<MissedCalls />} />
                                        <Route path="/admin/makeupScheduler" element={<MakeupDashboard />} />
                                        <Route path="/admin/allTestResults" element={<TestResults />} />
                                        <Route path="/admin/apTestProgress" element={<APTestProgress />} />
                                        <Route path="/admin/placementTestProgress" element={<PlacementTestProgress />} />
                                        <Route path="/admin/appointmentAvailability" element={<AppointmentAvailability />} />
                                        <Route path="/admin/emailDrafts" element={<EmailDrafts />} />
                                        <Route path="/admin/teachers" element={<Teachers />} />
                                        <Route path="/admin/potentialTeachers" element={<PotentialTeachers />} />
                                        <Route path="/admin/courses" element={<Courses />} />
                                        <Route path="/admin/courses/:id" element={<CourseInfo />} />
                                        <Route path="/admin/competition" element={<Competitions />} />
                                        <Route path="/admin/zoom" element={<ZoomRooms />} />
                                        <Route path="/admin/textbooks" element={<Textbooks />} />
                                        <Route path="/admin/textbooks/:id" element={<TextbookExercises />} />
                                        <Route path="/admin/tests" element={<Tests />} />
                                        <Route path="/admin/tests-v2" element={<TestLibrary />} />
                                        <Route path="/admin/tests-v2/:id/edit" element={<AddEditTestV2 key="edit" />} />
                                        <Route path="/admin/tests-v2/add" element={<AddEditTestV2 key="add" />} />
                                        <Route path="/admin/tests-v2/generate" element={<GenerateTestWizard />} />
                                        <Route path="/admin/question-bank" element={<QuestionBank />} />
                                        <Route path="/admin/tags" element={<TagManager />} />
                                        <Route path="/admin/tests/:id" element={<ViewTest />} />
                                        <Route path="/admin/tests/:id/editTest" element={<EditTest />} />
                                        <Route path="/admin/testResults" element={<TestResults />} />
                                        {/* <Route path="/admin/zoom/assign" element={<ZoomAssignPage />} /> */}
                                        <Route path="/admin/addStudent" element={<AddStudent />} />
                                        <Route path="/admin/addTeacher" element={<AddTeacher />} />
                                        <Route path="/admin/addCourse" element={<AddCourse />} />
                                        <Route path="/admin/addSemester" element={<AddSemester />} />
                                        <Route path="/admin/addZoomRoom" element={<AddZoomRoom />} />
                                        <Route path="/admin/addTextbook" element={<AddTextbook />} />
                                        <Route path="/admin/addTest" element={<AddTest />} />
                                        <Route path="/admin/homework" element={<AdminHomework />} />
                                        <Route path="/admin/homework-key-review" element={<KeyRemediationReview />} />
                                        <Route path="/admin/questions" element={<AdminQuestions />} />
                                        <Route path="/admin/schoolMaterials" element={<AdminSchoolMaterials />} />
                                        <Route path="/admin/calendar" element={<Calendar />} />
                                        <Route path="/admin/paycheck-calculator" element={<PaycheckCalculator />} />
                                        <Route path="/admin/news-letter-emails" element={<NewsLetters />} />
                                        <Route path="/admin/vice-president-memos" element={<VicePresidentMemos />} />
                                        <Route path="/admin/manager-memos" element={<ManagerMemos />} />
                                        <Route path="/admin/data" element={<DataPage />} />
                                        <Route path="/admin/reports" element={<Reports />} />
                                        <Route path="/admin/reports/generate" element={<ReportGeneration />} />
                                        <Route path="/admin/reports/progress/:batchId" element={<ReportProgress />} />
                                        <Route path="/admin/reports/:reportId" element={<ReportViewer />} />
                                        <Route path="/admin/newsletters" element={<Newsletters />} />
                                        <Route path="/admin/newsletters/competition" element={<Newsletters />} />
                                        <Route path="/admin/newsletters/admission" element={<Newsletters />} />
                                        <Route path="/admin/newsletters/generate" element={<NewsletterGeneration />} />
                                        <Route path="/admin/newsletters/progress/:nid" element={<NewsletterProgress />} />
                                        <Route path="/admin/newsletters/:nid/save-ai-competitions" element={<AICompetitionSavePage />} />
                                        <Route path="/admin/newsletters/:nid" element={<NewsletterViewer />} />
                                        <Route path="/admin/classLogBatch" element={<ClassLogBatch />} />
                                        <Route path="/admin/parentPortalLink" element={<ParentPortalLinkPage />} />
                                        <Route path="/admin/payment-links" element={<PaymentLinksPage />} />
                                        <Route path="/admin/ettReports" element={<ETTReports />} />
                                        <Route path="/admin/ettReports/:userId/:testId" element={<ETTReportDetail />} />
                                        <Route path="/admin/prepPrograms" element={<PrepPrograms />} />
                                        <Route path="/admin/prepPrograms/dev" element={<PrepDevTools />} />
                                        <Route path="/admin/prepPrograms/new" element={<PrepProgramEditor />} />
                                        <Route path="/admin/prepPrograms/:uuid/edit" element={<PrepProgramEditor />} />
                                        <Route path="/admin/prepPrograms/:uuid/dashboard" element={<PrepProgramDashboard />} />
                                        {process.env.NODE_ENV === 'development' && (
                                            <Route path="/admin/dev/email-followups" element={<EmailFollowupsDev />} />
                                        )}
                                    </Route>
                                    <Route element={<SignInUpLayout/>}>
                                        <Route path="/signin" element={<Signin />} />
                                        <Route path="/signup" element={<Signup />} />
                                        <Route path="/forgot-password" element={<ForgotPassword />} />
                                        <Route path="/reset-password" element={<ResetPassword />} />
                                    </Route>
                                    <Route element={<ClassesLayout />}>
                                        <Route path="/classrooms/classes" element={<Classes />} />
                                    </Route>
                                    <Route element={<ClassRoomLayout />}>
                                        <Route path="/classrooms/:id/home" element={<ClassRoomHome />} />
                                        <Route path="/classrooms/:id/announcements" element={<Announcements />} />
                                        <Route path="/classrooms/:id/people" element={<ClassRoomPeople />} />
                                        <Route path="/classrooms/:id/homework" element={<Homework />} />
                                        <Route path="/classrooms/:id/homework/:hid" element={<Homework />} />
                                        <Route path="/classrooms/:id/homework/:hid/grading" element={<HwGrading />} />
                                        <Route path="/classrooms/:id/homework/:hid/submissions" element={<SubmitPage />} />
                                        <Route path="/classrooms/:id/homework/:hid/submissions/attempts" element={<HWQuestionsAttempts />} />
                                        <Route path="/classrooms/:id/homework/:hid/essay-feedback/:answerId" element={<EssayFeedbackPage />} />
                                        <Route path="/classrooms/:id/modules" element={<Modules />} />
                                        <Route path="/classrooms/:id/class-logs" element={<ClassLogs />} />
                                        <Route path="/classrooms/:id/class-materials" element={<ClassMaterials />} />
                                        <Route path="/classrooms/:id/tests" element={<Test />} />
                                        <Route path="/classrooms/:id/tests/:tid/grading" element={<TestResult />} />
                                        <Route path="/classrooms/:id/test/:tid/submissions" element={<TestSubmitPage />} />
                                        <Route path="/classrooms/:id/test/:tid/student/:sid/submission" element={<StudentResult />} />
                                        <Route path="/classrooms/:id/test-v2/:courseTestId" element={<TestSessionV2 />} />
                                        <Route path="/classrooms/:id/test-v2/:courseTestId/grading" element={<TestResultV2 />} />
                                        <Route path="/classrooms/:id/test-v2/:courseTestId/review" element={<TestReviewV2 />} />
                                        <Route path="/classrooms/:id/test-v2/:courseTestId/result/:sessionId" element={<StudentResultV2 />} />
                                        <Route path="/classrooms/:id/zoom-recordings" element={<ZoomRecordings />} />
                                        <Route path="/classrooms/:id/questions" element={<Questions />} />
                                        <Route path="/classrooms/:id/ett-reports" element={<ClassroomETTReports />} />
                                        <Route path="/classrooms/:id/ett-reports/:ettUserId/:testId" element={<ClassroomETTReportDetail />} />
                                    </Route>
                                    <Route path="/teacher-review/:sessionId" element={<TeacherReviewPage />} />
                                    <Route path="/maintenance" element={<Navigate to={"/signin"} />} />
                                </>
                            )}
                        </Routes>
                    </div>
                </SnackbarProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
}

export default App;
